import { decimalToSexagesimal, getDistance, sexagesimalToDecimal } from 'geolib';
import proj4 from 'proj4';
import { useEffect, useRef, useState } from 'react';

import { IMapSizes } from '../MapSizeContext';

const useMapTranslation = (
  leftUpperCorner: any,
  rightLowerCorner: any,
  sizes: IMapSizes
) => {
  const startEdgeRef = useRef({
    x: 0,
    y: 0,
  });

  const endEdgeRef = useRef({
    x: 0,
    y: 0,
  });
  const scalingFactorRef = useRef({
    x: 1,
    y: 1,
    distanceFactor: 1,
  });

  // TODO: This is a hack, and a bad one at that, something confusing is happening here. this is a temporary fix,
  // will fix this later.
  const [recalculateion, setRecalculation] = useState(0);
  const destStr = 'EPSG:3857';
  const srcStr = 'EPSG:4326';

  useEffect(() => {
    setRecalculation((cal) => cal + 1);
    if (
      !leftUpperCorner ||
      leftUpperCorner.length === 0 ||
      !rightLowerCorner ||
      rightLowerCorner.length === 0
    ) {
      return;
    }
    const distanceInMeters = getDistance(
      {
        latitude: leftUpperCorner[1],
        longitude: leftUpperCorner[0],
      },
      {
        latitude: rightLowerCorner[1],
        longitude: leftUpperCorner[0],
      }
    );
    const tlDecimal = leftUpperCorner.map((x: any) => sexagesimalToDecimal(x));
    const brDecimal = rightLowerCorner.map(sexagesimalToDecimal);
    const [tl_long, tl_lat] = proj4(srcStr, destStr, tlDecimal);
    const [br_long, br_lat] = proj4(srcStr, destStr, brDecimal);

    startEdgeRef.current = {
      x: tl_long,
      y: tl_lat,
    };
    endEdgeRef.current = {
      x: br_long,
      y: br_lat,
    };
    scalingFactorRef.current = {
      x: Math.abs(endEdgeRef.current.x - startEdgeRef.current.x) / sizes.width,
      y: Math.abs(endEdgeRef.current.y - startEdgeRef.current.y) / sizes.height,
      distanceFactor: sizes.width / distanceInMeters,
    };
    (window as any).geolib = {
      getDistance,
      decimalToSexagesimal,
      sexagesimalToDecimal,
      proj4,
    };
  }, [leftUpperCorner, rightLowerCorner]);

  return {
    rerender: recalculateion,
    distanceToPixel: (dist: any) =>
      dist * scalingFactorRef.current.distanceFactor,
    xyToLatLang: (x: number, y: number) => {
      const startEdge = startEdgeRef.current;
      const endEdge = endEdgeRef.current;
      const scalingFactor = scalingFactorRef.current;

      const localX = x * scalingFactor.x;
      const localY = y * scalingFactor.y;
      const x3857 = startEdge.x + localX;
      const y3857 = startEdge.y - localY;

      const destCord = proj4(destStr, srcStr, [x3857, y3857]);
      const [long, lat] = destCord;

      // console.log('CaptureBTWidget xyToLatLang ', {
      //   clientWidth: mapElement.clientWidth,
      //   clientHeight: mapElement.clientHeight,
      //   scalingFactor,
      //   x,
      //   y,
      //   offsetTop: mapElement.offsetTop,
      //   offsetLeft: mapElement.offsetLeft,
      //   startEdge,
      //   endEdge,
      // });

      if (!lat || !long) {
        return ['', '', '', ''];
      }
      return [
        `${decimalToSexagesimal(lat)}`,
        ` ${lat > 0 ? 'N' : 'S'}`,
        `${decimalToSexagesimal(long)}`,
        `${long > 0 ? 'E' : 'W'}`,
      ];
    },
    latLangToXY: (longitude: string, latitude: string) => {
      const startEdge = startEdgeRef.current;
      const endEdge = endEdgeRef.current;
      const scalingFactor = scalingFactorRef.current;
      const longitudeDecimal = sexagesimalToDecimal(longitude);
      const latitudeDecimal = sexagesimalToDecimal(latitude);
      const [x3857, y3857] = proj4(srcStr, destStr, [
        longitudeDecimal,
        latitudeDecimal,
      ]);
      // console.log('CaptureBTWidget latLongXY ', {
      //   longitudeDecimal,
      //   latitudeDecimal,
      //   clientWidth: mapElement.clientWidth,
      //   clientHeight: mapElement.clientHeight,
      //   x3857,
      //   y3857,
      //   offsetTop: mapElement.offsetTop,
      //   offsetLeft: mapElement.offsetLeft,
      //   startEdge,
      //   endEdge,
      //   scalingFactor,
      // });

      const localX = x3857 - startEdge.x;
      const localY = startEdge.y - y3857;

      const pixelX = localX / scalingFactor.x;
      const pixelY = localY / scalingFactor.y;

      return [pixelX, pixelY];
    },
  };
};

export default useMapTranslation;
